export default "__VITE_ASSET__B7BVx7_w__"